import React from 'react'
import "./home.css"
import { Link } from 'react-router-dom'
import img1 from "../assest/imgs/AI3.jpg"
import img2 from "../assest/imgs/Hardware1.jpg"
import img3 from "../assest/imgs/Apps1.jpg"
import img4 from "../assest/imgs/Programming1.jpg"
import img5 from "../assest/imgs/Apps3.jpg"

const Home = () => {
  const posts =[
    {
      id:1,
      title: "Lorem ipsum dolor, sit amet consectetur adipisicing.",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
      img: img1
    },
    {
      id:2,
      title: "Lorem ipsum dolor, sit amet consectetur adipisicing.",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
      img: img2
    },
    {
      id:3,
      title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
      img:img3
    },
    {
      id:4,
      title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
      img: img4
    },
    {
      id:5,
      title:  "Lorem ipsum dolor, sit amet consectetur adipisicing.",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor sunt fugiat voluptatibus eligendi adipisci eveniet facere culpa incidunt labore in odio aspernatur quasi vero ipsum repellendus, rerum similique voluptatem neque!",
      img:img5
    }
  ];
  return (
    <div className='home'>
      <div className="posts">
        {posts.map(post=>
        <div className="post" key={post.id}>
          <div className="img">
            <img src={post.img} alt="" />
          </div>
          <div className="Content">
            <Link className="link" to={`/post/${post.id}`}> 
            <h1>{post.title}</h1>
            </Link>
            <p >{post.desc}</p>
            <button>Read More</button>
          </div>
        </div>
          )}
      </div>
    </div>
  )
}

export default Home